import { Link, useRouteError } from 'react-router';

/** Shown when a page crashes or its code chunk fails to load (e.g. offline after an update). */
export function RouteError() {
  const err = useRouteError() as Error | undefined;
  const chunk = /Failed to fetch dynamically imported module|Importing a module script failed/i.test(err?.message ?? '');
  return (
    <div className="page page-narrow">
      <div className="card card-pad-lg stack" role="alert">
        <h1>{chunk ? 'This page needs a connection' : 'Something went wrong'}</h1>
        <p className="muted">{chunk ? 'This part of the app has not been saved on your device yet. Connect to the internet and try again.' : 'Please try again. If it keeps happening, let the LGU know.'}</p>
        <div className="row row-wrap">
          <button className="btn" onClick={() => window.location.reload()}>
            Try again
          </button>
          <Link to="/" className="btn btn-secondary">
            Home
          </Link>
          <a href="tel:911" className="btn btn-emergency">
            Call 911
          </a>
        </div>
      </div>
    </div>
  );
}
